import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";

export type ReservationLine = {
  id: string;
  activityId: string | null;
  slug: string | null;
  title: string;
  city: string;
  startAt: string;
  lineTotal: number;
};

export type ReservationAddonLine = {
  variantId: string;
  name: string;
  label: string;
  quantity: number;
  lineTotal: number;
};

export type Reservation = {
  id: string;
  ref: string;
  title: string;
  city: string;
  address?: string;
  /** Set only for a transfer, which has no meeting point; see the API. */
  transferPlaces?: { kind: "accommodation" | "restaurant" | "club" | "camp"; value: string }[];
  guests: number;
  guestLabel: string;
  startAt: string;
  /**
   * End of a flexible package's window ("15:00"): the booking reads
   * "13:00–15:00", the hour confirmed by our team. Null or missing = exact time.
   */
  reservationTimeEnd?: string | null;
  durationMin: number;
  priceAmount: number;
  currency: string;
  status: "pending" | "confirmed" | "completed" | "cancelled";
  /**
   * The booked activity's category template ("restaurant", "transfer", ...).
   * Optional: the API does not send it yet. A restaurant row never shows an
   * amount (tables are free), so the account page reads this when present.
   */
  template?: string | null;
  image?: string;
  activities: ReservationLine[];
  addons: ReservationAddonLine[];
};

export const reservationsApi = {
  listMine: async (): Promise<Reservation[]> =>
    unwrap(await api.me.reservations.get()).reservations,
};
